module.exports = __webpack_public_path__ + "static/media/container10.8718117a.jpg";